// extracted by mini-css-extract-plugin
var _1 = "AvatarLinkGroup__extraAvatarHide--phE9q";
var _2 = "AvatarLinkGroup__extraLink--fllTN";
var _3 = "AvatarLinkGroup__linkAvatar--COgo9";
var _4 = "AvatarLinkGroup__main--OwurQ";
var _5 = "AvatarLinkGroup__mainCenter--O7BJa AvatarLinkGroup__main--OwurQ";
var _6 = "AvatarLinkGroup__name--GTgys OfficeGeneral__robotoSlab--GdBSw OfficeGeneral__robotoMedium--itFSf CoreGeneral__robotoMedium--xrjYk";
var _7 = "AvatarLinkGroup__nameCenter--I0uNH AvatarLinkGroup__name--GTgys OfficeGeneral__robotoSlab--GdBSw OfficeGeneral__robotoMedium--itFSf CoreGeneral__robotoMedium--xrjYk";
var _8 = "AvatarLinkGroup__outer--uKLoZ";
var _9 = "AvatarLinkGroup__outerSelected--mfjvo AvatarLinkGroup__outer--uKLoZ";
export { _1 as "extraAvatarHide", _2 as "extraLink", _3 as "linkAvatar", _4 as "main", _5 as "mainCenter", _6 as "name", _7 as "nameCenter", _8 as "outer", _9 as "outerSelected" }
